<template>
  <div class="procesos-container">
    <!-- Unified Container -->
    <div class="unified-container">
      <!-- Header Section -->
      <div class="header-section">
        <div class="title-section">
          <v-icon class="title-icon" color="white"
            >mdi-application-settings</v-icon
          >
          <div class="title-text">
            <h1 class="main-title">TODOS LOS PROCESOS</h1>
            <p class="subtitle">Gestión integral de procesos de compra</p>
          </div>
        </div>
        <div class="header-actions">
          <v-btn
            color="white"
            class="export-btn"
            @click="downloadExcel"
            elevation="2"
          >
            <v-icon left>mdi-file-excel</v-icon>
            EXPORTAR EXCEL
          </v-btn>
        </div>
      </div>

      <!-- Search Section -->
      <div class="search-section">
        <div class="search-card">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar Proceso"
            solo
            flat
            hide-details
            class="search-field"
          ></v-text-field>
        </div>
      </div>

      <!-- Dialog observaciones -->
      <v-dialog
        v-model="dialog"
        persistent
        :overlay="true"
        width="90%"
        overlay-color="black"
        overlay-opacity="0.8"
      >
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: white"
              ><v-icon color="white">mdi-clipboard-edit-outline</v-icon>
              Proceso
            </span>
          </v-card-title>
          <!-- componente del modal para agregar y actualizar -->

          <div style="width: 95%; margin: 3rem 0rem 0rem 2rem">
            <v-layout wrap>
              <v-flex
                xs9
                sm9
                md9
                style="border-top: 1px solid black; border-left: 1px solid"
              >
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border: solid 1px black; border-right: 0px"
                class="displayCenter fondo"
              >
                <span><strong>Proveedor 1</strong></span>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border: solid 1px black; border-right: 0px"
                class="displayCenter fondo"
              >
                <span><strong>Proveedor 2</strong></span>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border: solid 1px black"
                class="displayCenter fondo"
              >
                <span><strong>Proveedor 3</strong></span>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex
                xs2
                sm2
                md2
                style="border: solid 1px black; border-right: 0px"
                class="displayCenter fondo"
              >
                <strong>DESCRIPCION</strong>
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                style="border: solid 1px black"
                class="displayCenter fondo"
              >
                <strong>DETALLE TÉCNICO</strong>
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                style="border: solid 1px black; border-right: 0px"
                class="displayCenter fondo"
              >
                <strong>ARGUMENTO PARA LA COMPRA</strong>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border: solid 1px black"
                class="displayCenter fondo"
              >
                <strong>CANT</strong>
              </v-flex>
              <v-layout wrap>
                <v-flex
                  xs4
                  sm4
                  md4
                  style="border: solid 1px black"
                  class="displayCenter fondo"
                >
                  <span style="font-size: 14px"
                    ><strong>VALOR UNITARIO</strong></span
                  >
                </v-flex>
                <v-flex
                  xs4
                  sm4
                  md4
                  style="border: solid 1px black"
                  class="displayCenter fondo"
                >
                  <span style="font-size: 14px"
                    ><strong>VALOR UNITARIO</strong></span
                  >
                </v-flex>
                <v-flex
                  xs4
                  sm4
                  md4
                  style="border: solid 1px black"
                  class="displayCenter fondo"
                >
                  <span style="font-size: 14px"
                    ><strong>VALOR UNITARIO</strong></span
                  >
                </v-flex>
              </v-layout>
            </v-layout>
            <v-layout
              wrap
              v-for="(item, index) in editedItem.infoProceso"
              :key="index"
              style="border: solid 1px black; border-top: 0px"
            >
              <v-flex
                xs2
                sm2
                md2
                style="border-right: solid 1px black"
                class="displayCenter"
              >
                {{ item.concepto }}
              </v-flex>
              <v-flex xs3 sm3 md3 style="border-right: solid 1px black">
                {{ item.expecificaciones }}
              </v-flex>
              <v-flex xs3 sm3 md3 style="border-right: solid 1px black">
                {{ item.observaciones }}
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border-right: solid 1px black"
                class="displayCenter"
              >
                {{ item.cantidad }}
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border-right: solid 1px black"
                class="displayEnd"
              >
                {{
                  editedItem.proveedor1.valores[index].valorUnitario | currency
                }}
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border-right: solid 1px black"
                class="displayEnd"
              >
                {{
                  editedItem.proveedor2.valores[index].valorUnitario | currency
                }}
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border-right: solid 1px black"
                class="displayEnd"
              >
                {{
                  editedItem.proveedor3.valores[index].valorUnitario | currency
                }}
              </v-flex>
            </v-layout>

            <v-layout
              wrap
              class="d-flex"
              style="border: solid 1px black; border-top: 0px"
            >
              <v-flex> </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-bottom: 0px;
                "
              >
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-if="dialog === true"
                    style="border-bottom: solid 1px black"
                  >
                    <label for=""
                      ><strong>SUBTOTAL</strong><br />{{
                        editedItem.proveedor1.subTotal | currency
                      }}</label
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-bottom: 0px;
                "
              >
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-if="dialog === true"
                    style="border-bottom: solid 1px black"
                  >
                    <label for=""
                      ><strong>SUBTOTAL</strong><br />{{
                        editedItem.proveedor2.subTotal | currency
                      }}</label
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-bottom: 0px;
                  border-right: 0px;
                "
              >
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-if="dialog === true"
                    style="border-bottom: solid 1px black"
                  >
                    <label for=""
                      ><strong>SUBTOTAL</strong><br />{{
                        editedItem.proveedor3.subTotal | currency
                      }}</label
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex
                xs6
                sm6
                md6
                v-if="dialog === true"
                style="border: solid 1px black; border-top: 0px"
                class="displayCenter fondo"
              >
                <label for=""><strong>NOMBRE EMPRESA</strong></label>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialog === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <label for="">{{ editedItem.proveedor1.nombreEmpresa }}</label>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialog === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <label for="">{{ editedItem.proveedor2.nombreEmpresa }}</label>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialog === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <label for="">{{ editedItem.proveedor3.nombreEmpresa }}</label>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex
                xs6
                sm6
                md6
                v-if="dialog === true"
                style="border: solid 1px black; border-top: 0px"
                class="displayCenter fondo"
              >
                <label for=""> <strong>ARGUMENTO PARA LA COMPRA</strong></label>
              </v-flex>
              <v-flex
                xs6
                sm6
                md6
                v-if="dialog === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <label for="">{{ editedItem.observacion }}</label>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex
                xs6
                sm6
                md6
                v-if="dialog === true"
                style="border: solid 1px black; border-top: 0px"
                class="displayCenter fondo"
              >
                <label for=""> <strong>ARCHIVO ADJUNTO</strong></label>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialog === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <v-btn
                  v-if="editedItem.ruta_img1"
                  @click="viewImage(editedItem.ruta_img1)"
                  outlined
                  color="primary"
                >
                  Ver Imagen
                </v-btn>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialog === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <v-btn
                  v-if="editedItem.ruta_img2"
                  @click="viewImage(editedItem.ruta_img2)"
                  valores
                  color="primary"
                >
                  Ver Imagen
                </v-btn>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialog === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <v-btn
                  v-if="editedItem.ruta_img3"
                  @click="viewImage(editedItem.ruta_img3)"
                  outlined
                  color="primary"
                >
                  Ver Imagen
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout wrap class="mt-5">
              <v-flex xs3 sm3 md3>
                <v-text-field
                  disabled
                  label="Maira Londoño"
                  class="mr-4"
                ></v-text-field>
                <label for="">ELABORADO POR</label>
                <br />
                Creado:
                <label for="">{{ editedItem.fechaProveedores }}</label>
              </v-flex>
              <v-flex xs6 class="d-flex">
                <v-layout
                  wrap
                  v-for="(item, index) in editedItem.aprobacion"
                  :key="index"
                >
                  <v-flex xs12 sm12 md12 v-if="item.rol === 'DIRECTOR AREA'">
                    <v-text-field
                      :value="item.firma"
                      disabled
                      class="mr-4"
                    ></v-text-field>
                    <label for="">APROBACION DIRECTOR DE ÁREA</label>
                    <br />
                    Aprobado:
                    <label for="">{{ item.fechaAprobacion }}</label>
                  </v-flex>
                  <v-flex xs12 sm12 md12 v-if="item.rol === 'CONTROL INTERNO'">
                    <v-text-field disabled :value="item.firma"></v-text-field>
                    <label for="">REVISIÓN DIRECCION FINANCIERA</label>
                    <br />
                    Aprobado:
                    <label for="">{{ item.fechaAprobacion }}</label>
                  </v-flex>
                  <v-flex xs12 sm12 md12 v-if="item.rol === 'GERENTE'">
                    <v-text-field disabled :value="item.firma"></v-text-field>
                    <label for="">APROBACIÓN DE LA GERENCIA</label>
                    <br />
                    Aprobado:
                    <label for="">{{ item.fechaAprobacion }}</label>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>

          <!-- botones para cancelar y agregregar y validacion de campos vacios -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn elevation="2" color="#f7e506" @click="close">cerrar</v-btn>
            <!-- <v-btn elevation="2"  color="red" @click="contenidoPdf"
                            > IMPRIMIR</v-btn
                        > -->
          </v-card-actions>
          <!-- <pre>{{editedItem}}</pre>  -->
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogRechazar"
        persistent
        :overlay="true"
        width="60%"
        overlay-color="black"
        overlay-opacity="0.8"
      >
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: white"
              ><v-icon color="white">mdi-application-cog</v-icon>Rechazar
              Proceso</span
            >
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-textarea
                    v-model="observaciones"
                    label="Argumento para la compra"
                    maxlength="80"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <!-- botones para cancelar y agregregar y validacion de campos vacios -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#f7e506" @click="close1">Cancelar</v-btn>
            <v-btn color="#f7e506" @click="rechazarProceso(editedItem)"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Table Section -->
      <div class="table-section">
        <div class="table-card">
          <v-data-table
            :headers="headers"
            :items="procesos"
            :search="search"
            class="modern-table"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [10, 20, 50],
              'items-per-page-text': 'Filas por página:',
            }"
          >
            <template v-slot:no-data>
              <v-alert
                :value="true"
                color="#F44336"
                icon="mdi-alert"
                outlined
                type="warning"
                prominent
                border="left"
              >
                <strong>No</strong> se encontro su busqueda
              </v-alert>
            </template>
            <!--acciones de los datos obtenidos del arreglo-->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="action-icons">
                <div v-if="item.aprobacion === null" class="action-group">
                  <v-icon
                    class="action-icon approve-icon"
                    @click="aceptar(item)"
                    title="Aprobar"
                  >
                    mdi-check-bold
                  </v-icon>
                  <v-icon
                    class="action-icon reject-icon"
                    @click="rechazar(item)"
                    title="Rechazar"
                  >
                    mdi-close-thick
                  </v-icon>
                </div>
              </div>
            </template>

            <template v-slot:[`item.pdfGeneral`]="{ item }">
              <v-icon
                v-if="item.estado !== '3'"
                class="pdf-icon"
                @click="modalPdf(item)"
                title="Ver PDF"
              >
                mdi-file-pdf-box
              </v-icon>
            </template>
            <template v-slot:[`item.estado`]="{ item }">
              <div v-if="item.estado === '0'">
                <v-chip outlined class="ma-2" color="red"> CANCELADO </v-chip>
              </div>
              <div v-if="item.estado === '1'">
                <v-chip outlined class="ma-2" color="orange darken-2">
                  GERENTE
                </v-chip>
              </div>
              <div v-if="item.estado === '3' || item.estado === '2'">
                <v-chip outlined class="ma-2" color="amber accent-4">
                  COMPRAS
                </v-chip>
              </div>
              <div v-if="item.estado === '5'">
                <v-chip outlined class="ma-2" color="green darken-4">
                  DIRECCION FINANCIERA
                </v-chip>
              </div>
              <div v-if="item.estado === '4'">
                <v-chip outlined class="ma-2" color="green">
                  APROBACION DIRECTOR AREA
                </v-chip>
              </div>
              <div v-if="item.estado === '6'">
                <v-chip outlined class="ma-2" color="green">
                  APROBACION GERENTE
                </v-chip>
              </div>
              <div v-if="item.estado === '7'">
                <v-chip outlined color="green">REALIZAR COMPRA</v-chip>
              </div>
              <div v-if="item.estado === '8'">
                <v-chip outlined class="ma-2" color="green">
                  COMPRA REALIZADA
                </v-chip>
              </div>
            </template>
            <!-- Botón para abrir la card de subida de archivo -->
            <template v-slot:[`item.archivo`]="{ item }">
              <!-- Mostrar botón "Ver Imagen" si ruta_img tiene un valor -->
              <v-btn
                v-if="item.ruta_img"
                @click="viewImage(item.ruta_img)"
                outlined
                color="primary"
                >Ver Imagen</v-btn
              >
            </template>
          </v-data-table>
        </div>
      </div>

      <v-dialog v-model="show" max-width="500">
        <v-card>
          <v-card-title>Fecha de Entrega</v-card-title>
          <v-card-text>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="fechaEntrega"
                  type="date"
                  label="Seleccionar fecha"
                  readonly
                  v-on="on"
                  @change="fechaEntregaError = false"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fechaEntrega"
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="realizarCompra(item)"
              outlined
              color="green"
              :disabled="isLoading"
            >
              REALIZAR COMPRA
              <v-progress-circular
                v-if="isLoading"
                indeterminate
                color="blue"
                size="20"
                class="ml-2"
              ></v-progress-circular>
            </v-btn>
            <v-btn color="red" outlined @click="cancelar">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Snackbar para notificaciones -->
      <v-snackbar
        v-model="snackbar"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
        color="#3b82f6"
        class="modern-snackbar"
      >
        {{ text }}
        <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
import Vue from "vue";
import swal from "sweetalert";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import VueCurrencyFilter from "vue-currency-filter";
Vue.use(VueCurrencyFilter, {
  symbol: "$",
  thousandsSeparator: ".",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: true,
});

export default {
  data() {
    return {
      show: false,
      isLoading: false,
      menu: false,
      fechaEntrega: null,
      fechaEntregaError: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      procesos: [],
      infoProcesos: [],
      valoresProveedores: [],
      dialog: false,
      dialogRechazar: false,
      observaciones: "",
      showUploadCard: false, // Controla la visibilidad de la card
      selectedFile: null, // Almacena el archivo seleccionado
      currentItem: null, // Almacena el item actual
      loading: false,
      loading3: false,
      headers: [
        {
          text: "ID",
          value: "idProceso",
          align: "center",
          class: "column",
        },
        {
          text: "CONCEPTO",
          value: "infoConcepto",
          align: "center",
          class: "column",
        },
        {
          text: "DIRECTOR",
          value: "nombre",
          align: "center",
          class: "column",
        },
        {
          text: "CREACION",
          value: "fechaCreacion",
          align: "center",
          class: "column",
        },
        // {
        //     text: "APROBACIÓN GERENTE",
        //     value: "fechaGerente",
        //     align: "center",
        //     class: "column",
        // },
        {
          text: "GENERAL",
          value: "pdfGeneral",
          align: "center",
          class: "column",
        },
        {
          text: "ESTADO",
          value: "estado",
          align: "center",
          class: "column",
        },
        {
          text: "FECHA ENTREGA",
          value: "fechaEntrega",
          align: "center",
          class: "column",
        },
      ],
      defaultItem: {
        id: "",
        concepto: "",
        cantidad: "",
        especificacion: "",
        observaciones: "",
        aprobacion: "",
      },
      editedIndex: -1,
      editedItem: {
        id: "",
        concepto: "",
        cantidad: "",
        especificacion: "",
        observaciones: "",
        aprobacion: "",
        observacion: "",
      },
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.obtenerApps();
  },
  methods: {
    openUploadCard(item) {
      this.currentItem = item;
      this.showUploadCard = true;
    },
    cancelUpload() {
      this.showUploadCard = false;
      this.selectedFile = null;
    },
    obtenerApps() {
      axios.get(`${env.endpoint}user/allProcesos`).then((res) => {
        this.procesos = res.data;
        this.procesos = this.procesos.map((proceso) => {
          proceso.infoConcepto = proceso.infoProceso
            .map((element) => element.concepto)
            .join(",");
          return proceso;
        });
        for (let index = 0; index <= this.procesos.length; index++) {
          this.infoProcesos = this.procesos[index].infoProceso;
        }
        for (let index = 0; index < this.infoProcesos.length; index++) {
          this.infoProcesos[index].append(
            "idProceso",
            this.procesos[index].idProceso
          );
        }
      });
    },
    rechazoItem(item) {
      this.editedIndex = this.procesos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog_observaciones = true;
    },
    editItem(item) {
      this.editedIndex = this.procesos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    close1() {
      this.dialogRechazar = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    // Método para cancelar la acción
    cancelar() {
      this.show = false;
    },

    viewImage(rutaImg) {
      window.open(rutaImg, "_blank");
    },

    aceptar(item) {
      swal({
        title: "Aceptar proceso",
        text: "Proceso aceptado satisfactoriamente",
        icon: "success",
        buttons: ["Cancelar", true],
      }).then((willDelete) => {
        if (willDelete) {
          const aceptar = new FormData();
          aceptar.append("idUser", localStorage.getItem("id"));
          aceptar.append("firma", localStorage.getItem("firma"));
          aceptar.append("rol", "DIRECTOR AREA");
          aceptar.append("idProceso", item.idProceso);
          aceptar.append("estado", 5);
          axios
            .post(`${env.endpoint}user/enviarAprobacion`, aceptar, {})
            .then((res) => {
              swal("Se ha enviado con exito!", {
                icon: "success",
              });
              setTimeout(() => {
                window.location.reload();
              }, 1500);
              this.procesos = res.data;
              this.obtenerApps();
              this.aprobarProceso(this.procesos);
              this.close();
            })
            .catch((error) => {
              this.text =
                "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
            })
            .finally(() => {
              this.close();
              this.obtenerApps();
              this.aprobarProceso(this.procesos);
            });
        } else {
          swal("Proceso de eviado sea cancelado");
        }
      });
    },
    rechazar(item) {
      this.editedIndex = this.procesos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogRechazar = true;
    },
    rechazarProceso(item) {
      const aceptar = new FormData();
      aceptar.append("idUser", localStorage.getItem("id"));
      aceptar.append("observacion", this.observaciones);
      aceptar.append("idProceso", item.idProceso);
      swal({
        title: "Este proceso sera eliminado permanentemente.",
        text: "Una vez eliminado no se podra recuperar.",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          axios
            .post(`${env.endpoint}user/denegarAprobacion`, aceptar, {})
            .then((res) => {
              swal("Se ha enviado con exito!", {
                icon: "success",
              });
              this.obtenerApps();
              this.close1();
            })
            .catch((error) => {
              this.text =
                "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
            })
            .finally(() => {
              this.editarinventario = res.data;
              this.obtenerApps();
              this.close1();
            });
        } else {
          swal("Proceso de enviado sea cancelado");
          this.close1();
        }
      });
    },
    modalPdf(item) {
      if (!item.proveedor1 && !item.Proveedor2 && !item.proveedor3) {
        swal({
          title: "No puedes visualizar",
          text: "Datos Cancelados",
          icon: "warning",
          button: "Cerrar",
        });
        return;
      } else {
        this.editedIndex = this.procesos.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      }
    },

    downloadExcel() {
      const reportes = [];
      try {
        for (let i = 0; i < this.procesos.length; i++) {
          const proceso = this.procesos[i];
          let item = {};
          item.ID = proceso.idProceso;
          item.Nombre_Director = proceso.nombre;
          item.Cedula = proceso.cedula;
          item.Correo = proceso.correo;
          item.Area = proceso.nombreArea;
          item.Fecha_creacion = proceso.fechaCreacion;
          item.Fecha_entrega = proceso.fechaEntrega;

          if (proceso.estado === "1") {
            item.Estado = "Gerencia";
          } else if (proceso.estado === "2") {
            item.Estado = "Compras";
          } else if (proceso.estado === "3") {
            item.Estado = "Proveedores";
          } else if (proceso.estado === "4") {
            item.Estado = "Pendiente aprobación director area";
          } else if (proceso.estado === "5") {
            item.Estado = "Pendiente aprobación dirección financiera";
          } else if (proceso.estado === "6") {
            item.Estado = "Pendiente aprobación gerencia";
          } else if (proceso.estado === "7") {
            item.Estado = "Realizar compra";
          } else if (proceso.estado === "8") {
            item.Estado = "Compra realizada";
          }

          // Extraer datos anidados proveedor 1
          // Info_Proceso: proceso.infoProceso ? JSON.stringify(proceso.infoProceso) : '',
          // Proveedor1_Valores: proceso.proveedor1 && proceso.proveedor1.valores ? JSON.stringify(proceso.proveedor1.valores) : '',
          item.Proveedor1_NombreEmpresa = proceso.proveedor1
            ? proceso.proveedor1.nombreEmpresa
            : "";
          item.Proveedor1_Nit = proceso.proveedor1
            ? proceso.proveedor1.nit
            : "";
          item.Proveedor1_Contacto = proceso.proveedor1
            ? proceso.proveedor1.contacto
            : "";
          item.Proveedor1_Direccion = proceso.proveedor1
            ? proceso.proveedor1.direccion
            : "";
          item.Proveedor1_Ciudad = proceso.proveedor1
            ? proceso.proveedor1.ciudad
            : "";
          item.Proveedor1_Telefono = proceso.proveedor1
            ? proceso.proveedor1.telefono
            : "";
          item.Proveedor1_Celular = proceso.proveedor1
            ? proceso.proveedor1.celular
            : "";
          item.Proveedor1_Correo = proceso.proveedor1
            ? proceso.proveedor1.correo
            : "";
          item.Proveedor1_FormaPago = proceso.proveedor1
            ? proceso.proveedor1.formaPago
            : "";
          item.Proveedor1_Garantia = proceso.proveedor1
            ? proceso.proveedor1.garantia
            : "";
          item.Proveedor1_Observaciones = proceso.proveedor1
            ? proceso.proveedor1.observaciones
            : "";
          item.Proveedor1_Iva = proceso.proveedor1
            ? proceso.proveedor1.iva
            : "";
          item.Proveedor1_Total = proceso.proveedor1
            ? proceso.proveedor1.total
            : "";
          // Extraer datos anidados proveedor 2
          item.Proveedor2_Nit = proceso.proveedor2
            ? proceso.proveedor2.nit
            : "";
          item.Proveedor2_NombreEmpresa = proceso.proveedor2
            ? proceso.proveedor2.nombreEmpresa
            : "";
          item.Proveedor2_Contacto = proceso.proveedor2
            ? proceso.proveedor2.contacto
            : "";
          item.Proveedor2_Direccion = proceso.proveedor2
            ? proceso.proveedor2.direccion
            : "";
          item.Proveedor2_Ciudad = proceso.proveedor2
            ? proceso.proveedor2.ciudad
            : "";
          item.Proveedor2_Telefono = proceso.proveedor2
            ? proceso.proveedor2.telefono
            : "";
          item.Proveedor2_Celular = proceso.proveedor2
            ? proceso.proveedor2.celular
            : "";
          item.Proveedor2_Correo = proceso.proveedor2
            ? proceso.proveedor2.correo
            : "";
          item.Proveedor2_FormaPago = proceso.proveedor2
            ? proceso.proveedor2.formaPago
            : "";
          item.Proveedor2_Garantia = proceso.proveedor2
            ? proceso.proveedor2.garantia
            : "";
          item.Proveedor2_Observaciones = proceso.proveedor2
            ? proceso.proveedor2.observaciones
            : "";
          item.Proveedor2_Iva = proceso.proveedor2
            ? proceso.proveedor2.iva
            : "";
          item.Proveedor2_Total = proceso.proveedor2
            ? proceso.proveedor2.total
            : "";
          // Extraer datos anidados proveedor 3
          item.Proveedor3_NombreEmpresa = proceso.proveedor3
            ? proceso.proveedor3.nombreEmpresa
            : "";
          item.Proveedor3_Nit = proceso.proveedor3
            ? proceso.proveedor3.nit
            : "";
          item.Proveedor3_Contacto = proceso.proveedor3
            ? proceso.proveedor3.contacto
            : "";
          item.Proveedor3_Direccion = proceso.proveedor3
            ? proceso.proveedor3.direccion
            : "";
          item.Proveedor3_Ciudad = proceso.proveedor3
            ? proceso.proveedor3.ciudad
            : "";
          item.Proveedor3_Telefono = proceso.proveedor3
            ? proceso.proveedor3.telefono
            : "";
          item.Proveedor3_Celular = proceso.proveedor3
            ? proceso.proveedor3.celular
            : "";
          item.Proveedor3_Correo = proceso.proveedor3
            ? proceso.proveedor3.correo
            : "";
          item.Proveedor3_FormaPago = proceso.proveedor3
            ? proceso.proveedor3.formaPago
            : "";
          item.Proveedor3_Garantia = proceso.proveedor3
            ? proceso.proveedor3.garantia
            : "";
          item.Proveedor3_Observaciones = proceso.proveedor3
            ? proceso.proveedor3.observaciones
            : "";
          item.Proveedor3_Iva = proceso.proveedor3
            ? proceso.proveedor3.iva
            : "";
          item.Proveedor3_Total = proceso.proveedor3
            ? proceso.proveedor3.total
            : "";

          console.log(item);
          reportes.push(item);
        }
      } catch (error) {
        console.log(error);
      }
      const data = XLSX.utils.json_to_sheet(reportes);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, `ReporteCompras.xlsx`);
    },

    // menosValor(item){
    //     let valoresProveedor1 =  item.proveedor1.valores;
    //     let valoresProveedor2 = item.proveedor2.valores;
    //     let valoresProveedor3 = item.proveedor3.valores;
    //     for (let index = 0; index < item.proveedor3.valores.length; index++) {
    //         let valoresFor = []
    //         let proveedor1 = Number(valoresProveedor1[index].valorTotal);
    //         let proveedor2 = Number(valoresProveedor2[index].valorTotal);
    //         let proveedor3 = Number(valoresProveedor3[index].valorTotal);
    //         if (proveedor1 <= proveedor2 && proveedor1 <= proveedor3 ) {
    //             valoresFor.push(proveedor1)
    //             valoresFor.push('proveedor1')
    //         }else if(proveedor2 <= proveedor1 && proveedor2 <= proveedor3){
    //                 valoresFor.push(proveedor2)
    //                 valoresFor.push('proveedor2')
    //         }else{
    //                 valoresFor.push(proveedor3)
    //                 valoresFor.push('proveedor3')
    //         }
    //         this.valoresProveedores.push(valoresFor)
    //     }
    // },
  },
};
</script>

<style scoped>
/* ===== DISEÑO MODERNO Y ELEGANTE ===== */
.procesos-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 3rem;
}

.unified-container {
  max-width: 1600px;
  margin: 0 auto;
  background: white;
  border-radius: 0;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* ===== HEADER SECTION ===== */
.header-section {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  padding: 2.5rem;
  color: white;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 50%,
    rgba(255, 255, 255, 0.05) 100%
  );
  pointer-events: none;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  position: relative;
  z-index: 2;
}

.title-icon {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.title-text {
  flex: 1;
}

.main-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
}

.subtitle {
  font-size: 1rem;
  margin: 0;
  opacity: 0.9;
  font-weight: 400;
}

.header-actions {
  position: relative;
  z-index: 2;
}

.export-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(10px) !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s ease !important;
}

.export-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2) !important;
}

/* ===== SEARCH SECTION ===== */
.search-section {
  padding: 2.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.search-card {
  max-width: 500px;
  margin: 0 auto;
}

.search-field {
  background: white !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
}

/* ===== TABLE SECTION ===== */
.table-section {
  padding: 0;
  background: white;
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
}

.table-card {
  padding: 0;
  background: white;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: visible;
}

/* ===== DISEÑO MINIMALISTA ELEGANTE PARA TABLA ===== */
.modern-table {
  background: white !important;
  border-radius: 0 !important;
  overflow: visible !important;
  box-shadow: none !important;
  border: none !important;
  min-width: 800px; /* Ancho mínimo para forzar scroll si es necesario */
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
  overflow-x: scroll !important; /* Cambiar a scroll para que siempre aparezca */
  overflow-y: visible !important;
  background: white !important;
  max-width: 100%;
}

/* Estilos para el scrollbar horizontal siempre visible */
.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  height: 12px !important; /* Más alto para mejor visibilidad */
  display: block !important;
  -webkit-appearance: none;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #e5e7eb !important; /* Más visible */
  border-radius: 6px !important;
  margin: 0 10px;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #64748b !important; /* Más oscuro para mejor visibilidad */
  border-radius: 6px !important;
  border: 2px solid #e5e7eb;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #475569 !important; /* Aún más oscuro al hover */
}

/* Para Firefox */
.modern-table >>> .v-data-table__wrapper {
  scrollbar-width: thin;
  scrollbar-color: #64748b #e5e7eb;
}

.modern-table >>> .v-data-table-header {
  background: white !important;
  border-bottom: 1px solid #e5e7eb !important;
  position: relative !important;
}

.modern-table >>> .v-data-table-header th {
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 0.9rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.8px !important;
  padding: 1.25rem 1rem !important;
  background: transparent !important;
  border-bottom: 2px solid #f3f4f6 !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr {
  transition: all 0.2s ease !important;
  border-bottom: 1px solid #f9fafb !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:nth-child(even) {
  background: #fafbfc !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:hover {
  background: #f8fafc !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr td {
  color: #1f2937 !important;
  font-weight: 400 !important;
  border-bottom: 1px solid #f3f4f6 !important;
  padding: 1.25rem 1rem !important;
  font-size: 0.9rem !important;
  line-height: 1.6 !important;
  vertical-align: middle !important;
}

/* ===== ICONOS DE ACCIONES MODERNOS ===== */
.action-icons {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  justify-content: center;
}

.action-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.action-icon {
  font-size: 20px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  padding: 4px !important;
  border-radius: 4px !important;
}

.approve-icon {
  color: #059669 !important;
}

.approve-icon:hover {
  color: #047857 !important;
  transform: scale(1.1) !important;
}

.reject-icon {
  color: #dc2626 !important;
}

.reject-icon:hover {
  color: #b91c1c !important;
  transform: scale(1.1) !important;
}

.pdf-icon {
  color: #dc2626 !important;
  font-size: 20px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  padding: 4px !important;
}

.pdf-icon:hover {
  color: #b91c1c !important;
  transform: scale(1.1) !important;
}

/* ===== FOOTER DE TABLA ===== */
.modern-table >>> .v-data-footer {
  background: white !important;
  border-top: 1px solid #e5e7eb !important;
  padding: 1.25rem !important;
  border-radius: 0 !important;
}

.modern-table >>> .v-data-footer__select {
  color: #6b7280 !important;
  font-weight: 500 !important;
  font-size: 0.9rem !important;
}

.modern-table >>> .v-data-footer__pagination {
  color: #6b7280 !important;
  font-weight: 500 !important;
  font-size: 0.9rem !important;
}

.modern-table >>> .v-data-footer .v-btn {
  background: #f3f4f6 !important;
  color: #374151 !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 6px !important;
  transition: all 0.2s ease !important;
  font-size: 0.9rem !important;
  padding: 0.6rem 0.9rem !important;
  font-weight: 500 !important;
}

.modern-table >>> .v-data-footer .v-btn:hover {
  background: #e5e7eb !important;
  border-color: #d1d5db !important;
  transform: translateY(-1px) !important;
}

/* ===== SNACKBAR MODERNO ===== */
.modern-snackbar {
  border-radius: 8px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
}

/* ===== ESTILOS PARA MODAL ===== */
.fondo {
  background-color: #f3f4f6;
}

.displayCenter {
  display: flex;
  justify-content: center;
  align-items: center;
  word-break: break-all;
  padding: 8px;
  font-size: 0.85rem;
  font-weight: 500;
}

.displayEnd {
  display: flex;
  justify-content: end;
  align-items: end;
  word-break: break-all;
  padding: 8px;
  font-size: 0.85rem;
}

.colorMin {
  background-color: #dbeafe;
}

/* ===== RESPONSIVE DESIGN ===== */
@media (max-width: 768px) {
  .procesos-container {
    padding: 1rem;
  }

  .unified-container {
    margin: 0;
    border-radius: 0;
  }

  .header-section {
    padding: 1.5rem;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .title-section {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .main-title {
    font-size: 1.5rem;
  }

  .search-section {
    padding: 1.5rem;
  }
}
</style>
